function getInitialState() {
    return {
        siteConf: {}
    };
}

function SiteConfReducer(state = getInitialState(), action = null) {
    switch (action.type) {
    default:
        return state;
    }
}

export default SiteConfReducer;
